import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import ResearcherProfiles from "./pages/ResearcherProfiles";
import ResearchAssistants from "./pages/ResearchAssistants";
import Dashboard from "./pages/Dashboard";
import VirtualRooms from "./pages/VirtualRoomsNew";
import Projects from "./pages/Projects";
import ProjectDetail from "./pages/ProjectDetail";
import ResearcherLibraryNew from "./pages/ResearcherLibraryNew";
import AdminDashboard from "./pages/AdminDashboard";
import AdminUsers from "./pages/AdminUsers";
import AdminResearchers from "./pages/AdminResearchers";
import AdminSubscriptions from "./pages/AdminSubscriptions";
import AdminReports from "./pages/AdminReports";
import AdminSupport from "./pages/AdminSupport";
import AdminAgreements from "./pages/AdminAgreements";
import AICreditsAnalytics from "./pages/AICreditsAnalytics";
import SubscriptionPlans from "./pages/SubscriptionPlans";
import SubscriptionSuccess from "./pages/SubscriptionSuccess";
import SubscriptionCancel from "./pages/SubscriptionCancel";
import TeamMatching from "./pages/TeamMatching";
import FAQPage from "./pages/FAQPage";
import UserGuidePage from "./pages/UserGuidePage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsPage from "./pages/TermsPage";
import CommunityForum from "./pages/CommunityForum";
import Announcements from "./pages/Announcements";
import ResetPassword from "./pages/ResetPassword";
import ChatbotWidget from "./components/ChatbotWidget";
import { Toaster } from "./components/ui/toaster";
import { AuthProvider } from "./context/AuthContext";
import { LanguageProvider } from "./context/LanguageContext";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/profiles" element={<ResearcherProfiles />} />
              <Route path="/research-assistants" element={<ResearchAssistants />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/virtual-rooms" element={<VirtualRooms />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/projects/:projectId" element={<ProjectDetail />} />
              <Route path="/library" element={<ResearcherLibraryNew />} />
              <Route path="/team-matching" element={<TeamMatching />} />
              <Route path="/subscription" element={<SubscriptionPlans />} />
              <Route path="/subscription-plans" element={<SubscriptionPlans />} />
              
              {/* Documentation Routes */}
              <Route path="/faq" element={<FAQPage />} />
              <Route path="/user-guide" element={<UserGuidePage />} />
              <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
              <Route path="/terms" element={<TermsPage />} />
              
              {/* Community Forum Routes */}
              <Route path="/forum" element={<CommunityForum />} />
              <Route path="/forum/:postId" element={<CommunityForum />} />
              <Route path="/announcements" element={<Announcements />} />
              
              {/* Password Reset Route */}
              <Route path="/reset-password" element={<ResetPassword />} />
              
              {/* Admin Routes */}
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/users" element={<AdminUsers />} />
              <Route path="/admin/researchers" element={<AdminResearchers />} />
              <Route path="/admin/subscriptions" element={<AdminSubscriptions />} />
              <Route path="/admin/reports" element={<AdminReports />} />
              <Route path="/admin/support" element={<AdminSupport />} />
              <Route path="/admin/agreements" element={<AdminAgreements />} />
              
              {/* AI Credits Analytics Route */}
              <Route path="/ai-credits" element={<AICreditsAnalytics />} />
              
              {/* PayPal Subscription Routes */}
              <Route path="/subscription-plans" element={<SubscriptionPlans />} />
              <Route path="/subscription/success" element={<SubscriptionSuccess />} />
              <Route path="/subscription/cancel" element={<SubscriptionCancel />} />
            </Routes>
          </BrowserRouter>
          <Toaster />
          <ChatbotWidget />
        </AuthProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;